import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "./App.scss";
import { NavigatingRoutes } from "./routes/Routes";
import useSetPrivilegesFromAuth from "./hooks/useSetPrivilegesFromAuth";
import { useEffect } from "react";
import { deleteAllCookies } from "./utils/Utils";
import { useAppVersionCheck } from "./hooks/useAppVersionCheck";
import { initChatStreamListener } from "./Components/Bank/report/widget/EWiChatBot/chatStreamHandler";

const App = () => {
  useAppVersionCheck();
  useSetPrivilegesFromAuth();
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      globalThis.dataLayer = globalThis.dataLayer || [];
      function gtag() {
        globalThis.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-HRN7TTHQ9N");
    }

    return deleteAllCookies();
  }, []);

  useEffect(() => {
    initChatStreamListener();
  }, []);

  return <NavigatingRoutes />;
};

export default App;
